module.exports = __webpack_public_path__ + "img/trivia-logo.3b226006.png";